import * as yup from 'yup';
import { Row, RenderConfig, Column, EMPTY_ARRAY, SelectInput, BOOLEAN_OPTIONS, NumberInput } from 'commons-ui';
import { onChangeConfigValAction } from './helper';

export const validationSchemaCreate = yup.object().shape({
	segmentName: yup.string().required('Segment Name is a required field'),
	weeklyCashbackLimit: yup.string().required('Weekly Limit is required'),
	overallCashbackLimit: yup.string().required('Overall Limit is required')
});

export const validationSchemaEdit = yup.object().shape({
	isEnabled: yup.boolean().required('Is Enabled is a required field'),
	isLiveSegmentEnabled: yup.boolean().required('Is Live Segment Enabled is a required field'),
	customAbsorptionAmount: yup.number().required('Custom Absorption Amount is a required field'),
	firstWithdrawalAbsorptionEnabled: yup.boolean().required('First Withdrawal Absorption Enabled is a required field')
});

export const FORM_FIELD_KEYS = {
	IS_ENABLED: 'isEnabled',
	IS_LIVE_SEGMENT_ENABLED: 'isLiveSegmentEnabled',
	CUSTOM_ABSORPTION_AMOUNT: 'customAbsorptionAmount',
	FIRST_WITHDRAWAL_ABSORPTION_ENABLED: 'firstWithdrawalAbsorptionEnabled'
};

export const FORM_LAYOUT_CONFIG = [
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.IS_ENABLED)]),
		new Column([new Row(FORM_FIELD_KEYS.IS_LIVE_SEGMENT_ENABLED)])
	]),
	new Row(null, EMPTY_ARRAY, [
		new Column([new Row(FORM_FIELD_KEYS.CUSTOM_ABSORPTION_AMOUNT)]),
		new Column([new Row(FORM_FIELD_KEYS.FIRST_WITHDRAWAL_ABSORPTION_ENABLED)])
	])
];

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.IS_ENABLED]: new RenderConfig()
		.setName('isEnabled')
		.setLabel('Is Enabled')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			required: true
		})
		.setToolTip('TDS Segment Name'),
	[FORM_FIELD_KEYS.IS_LIVE_SEGMENT_ENABLED]: new RenderConfig()
		.setName('isLiveSegmentEnabled')
		.setLabel('Is Live Segment Enabled')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: BOOLEAN_OPTIONS
			// onChangeCallback: onChangeConfigValAction
		})
		.setToolTip('Tds Config Weekly Limit'),
	[FORM_FIELD_KEYS.CUSTOM_ABSORPTION_AMOUNT]: new RenderConfig()
		.setName('customAbsorptionAmount')
		.setLabel('Custom Absorption Amount(₹)')
		.setRenderer(NumberInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			onChangeCallback: onChangeConfigValAction
		})
		.setToolTip('Tds Config Custom Absorption Amount'),
	[FORM_FIELD_KEYS.FIRST_WITHDRAWAL_ABSORPTION_ENABLED]: new RenderConfig()
		.setName('firstWithdrawalAbsorptionEnabled')
		.setLabel('First Withdrawal Absorption Enabled')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			options: BOOLEAN_OPTIONS,
			required: true
			// onChangeCallback: onChangeConfigValAction
		})
		.setToolTip('Tds Config First Withdrawal Absorption Enabled')
};
